import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, setDoc } from "firebase/firestore";

function PartnerSetup({ user, onComplete }) {
  const [step, setStep] = useState(1);
  const [shopPhone, setShopPhone] = useState('');
  const [shopData, setShopData] = useState({
    shopName: '',
    location: 'Tiranë',
    description: '',
    category: 'barbershop', // NEW: Defaults to barbershop
    // Expanded Schedule
    schedule: {
      Monday: { open: '09:00', close: '20:00', closed: false },
      Tuesday: { open: '09:00', close: '20:00', closed: false },
      Wednesday: { open: '09:00', close: '20:00', closed: false },
      Thursday: { open: '09:00', close: '20:00', closed: false },
      Friday: { open: '09:00', close: '20:00', closed: false },
      Saturday: { open: '09:00', close: '16:00', closed: false },
      Sunday: { open: '09:00', close: '12:00', closed: true },
    },
    barbers: []
  });

  const [newBarber, setNewBarber] = useState({ name: '', role: 'Professional' });

  const addBarber = () => {
    if (!newBarber.name) return;
    setShopData({ ...shopData, barbers: [...shopData.barbers, { ...newBarber, id: Date.now() }] });
    setNewBarber({ name: '', role: 'Professional' });
  };

  const handleFinish = async () => {
    try {
      await setDoc(doc(db, "shops", user.uid), { ...shopData, phone: shopPhone, ownerId: user.uid });
      await updateDoc(doc(db, "users", user.uid), { hasCompletedSetup: true });
      onComplete();
    } catch (err) { alert(err.message); }
  };

  return (
    <div className="setup-container">
      <div className="setup-card wide">
        <div className="progress-bar"><div className="progress" style={{ width: `${(step / 4) * 100}%` }}></div></div>

        {step === 1 && (
          <div className="setup-step">
            <h2>Business Identity</h2>
            
            {/* NEW: Category Selection */}
            <div style={{ display: 'flex', gap: '15px', marginBottom: '25px' }}>
              <div 
                onClick={() => setShopData({...shopData, category: 'barbershop'})}
                style={{ flex: 1, padding: '20px', border: shopData.category === 'barbershop' ? '2px solid #3b82f6' : '1px solid #e2e8f0', borderRadius: '16px', cursor: 'pointer', background: shopData.category === 'barbershop' ? '#eff6ff' : 'white', transition: '0.2s' }}
              >
                <div style={{fontSize: '35px'}}>💈</div>
                <h3 style={{margin: '10px 0 0 0', fontSize: '18px'}}>Barbershop</h3>
              </div>
              <div 
                onClick={() => setShopData({...shopData, category: 'hairsalon'})}
                style={{ flex: 1, padding: '20px', border: shopData.category === 'hairsalon' ? '2px solid #ec4899' : '1px solid #e2e8f0', borderRadius: '16px', cursor: 'pointer', background: shopData.category === 'hairsalon' ? '#fdf2f8' : 'white', transition: '0.2s' }}
              >
                <div style={{fontSize: '35px'}}>💇‍♀️</div>
                <h3 style={{margin: '10px 0 0 0', fontSize: '18px'}}>Hair Salon</h3>
              </div>
            </div>

            <input type="tel" placeholder="Business Phone Number" value={shopPhone} onChange={(e) => setShopPhone(e.target.value)} style={{ marginTop: '15px' }} required />
            <textarea placeholder="Brief description of your shop..." value={shopData.description} onChange={(e) => setShopData({...shopData, description: e.target.value})} />
            <button className="premium-login-btn" onClick={() => setStep(2)}>Next: Schedule</button>
          </div>
        )}

        {step === 2 && (
          <div className="setup-step">
            <h2>Weekly Schedule</h2>
            <div className="schedule-setup-list">
              {Object.keys(shopData.schedule).map(day => (
                <div key={day} className="day-row">
                  <span>{day}</span>
                  <input type="time" value={shopData.schedule[day].open} onChange={(e) => setShopData({...shopData, schedule: {...shopData.schedule, [day]: {...shopData.schedule[day], open: e.target.value}}})} />
                  <input type="time" value={shopData.schedule[day].close} onChange={(e) => setShopData({...shopData, schedule: {...shopData.schedule, [day]: {...shopData.schedule[day], close: e.target.value}}})} />
                  <label><input type="checkbox" checked={shopData.schedule[day].closed} onChange={(e) => setShopData({...shopData, schedule: {...shopData.schedule, [day]: {...shopData.schedule[day], closed: e.target.checked}}})} /> Closed</label>
                </div>
              ))}
            </div>
            <button className="premium-login-btn" onClick={() => setStep(3)}>Next: Team</button>
          </div>
        )}

        {step === 3 && (
          <div className="setup-step">
            <h2>Build Your Team</h2>
            <div className="barber-input-row">
              <input type="text" placeholder="Professional's Name" value={newBarber.name} onChange={(e) => setNewBarber({...newBarber, name: e.target.value})} />
              <button onClick={addBarber} className="add-btn">+</button>
            </div>
            <div className="added-barbers-list">
              {shopData.barbers.map(b => <div key={b.id} className="barber-tag">👤 {b.name}</div>)}
            </div>
            <button className="premium-login-btn" onClick={() => setStep(4)}>Review & Launch</button>
          </div>
        )}

        {step === 4 && (
          <div className="setup-step">
            <h2>Ready to Launch?</h2>
            <p>You can add specific services and prices once you enter your dashboard.</p>
            <button className="premium-login-btn" onClick={handleFinish}>Open My Business</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default PartnerSetup;